import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  imageContainer: {
    height: '80px !important',
    width: '175px !important',
  },
  tradeContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    width: '300px',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '16px',
  },
  tradeGrid: {
    display: 'grid',
    gridGap: theme.spacing(3),
    gridTemplateColumns: 'repeat(5, minmax(190px, 320px))',
    '@media (max-width: 1430px)': {
      maskImage:
        'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 20%, rgba(255,255,255,1) 80%, rgba(255,255,255,0) 100%)',
      display: 'grid',
      gridGap: theme.spacing(3),
      gridAutoFlow: 'row',
      gridTemplateRows: 'auto auto',
      gridTemplateColumns: 'repeat(5, minmax(190px, 320px))',
      overflowX: 'scroll',
      overflowY: 'hidden',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      padding: '0 20px',
    },
  },
  tradeImage: {
    filter: 'drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.08))',
    borderRadius: '6px',
    objectFit: 'cover',
    height: '80px !important',
    width: '175px !important',
  },
  viewMore: {
    textAlign: 'center',
    paddingTop: '34px',
    textDecorationLine: 'underline',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}));
